import React, { useState, useEffect } from 'react';
import eventsData from './Events.json';
import Link from '@mui/material/Link';
import Reelit from '../Images/Reel-it-in-for-the-Reefs.webp'

const Events = () => {
	const [visibleEvents, setVisibleEvents] = useState([]);
	const [currentDate, setCurrentDate] = useState('');

	useEffect(() => {
		// Function to get current date in YYYY-MM-DD format
		const getCurrentDateString = () => {
			const today = new Date();
			// Adjusting for timezone to ensure we're getting the local date
			const year = today.getFullYear();
			const month = String(today.getMonth() + 1).padStart(2, '0');
			const day = String(today.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		};

		// Set the current date
		const todayString = getCurrentDateString();
		setCurrentDate(todayString);

		// Function to filter events based on current date
		const filterEvents = () => {
			// Filter events that should be visible (current date is before or equal to hideAfter date)
			const filtered = eventsData.filter(event => {
				return todayString <= event.hideAfter;
			});

			setVisibleEvents(filtered);
		};

		// Run filter on component mount
		filterEvents();

		// Optional: Set up interval to check dates at midnight
		const setMidnightCheck = () => {
			const now = new Date();
			const tomorrow = new Date(now);
			tomorrow.setDate(tomorrow.getDate() + 1);
			tomorrow.setHours(0, 0, 0, 0);

			const timeUntilMidnight = tomorrow - now;

			return setTimeout(() => {
				setCurrentDate(getCurrentDateString());
				filterEvents();
				// Set up next day's check
				const intervalId = setMidnightCheck();
				return () => clearTimeout(intervalId);
			}, timeUntilMidnight);
		};

		const initialIntervalId = setMidnightCheck();

		// Clean up interval on component unmount
		return () => clearTimeout(initialIntervalId);
	}, []);

	// If no visible events, don't render the component
	if (visibleEvents.length === 0) {
		return null;
	}

	// Debug output - can be removed after confirming date is correct
	console.log("Current date for comparison:", currentDate);

	return (
		<div className="bg-[#fff6d6] text-[#032338] p-5">

			<div className="space-y-4">
				{visibleEvents.map(event => {
					// Format dates for display - using just dates, no times
					const formatDate = (dateString) => {
						// Create a date by parsing the YYYY-MM-DD string
						// When we parse the date string, we need to ensure it's interpreted as UTC
						// to avoid timezone issues
						const [year, month, day] = dateString.split('-');
						return new Date(year, parseInt(month) - 1, parseInt(day))
							.toLocaleDateString('en-US', {
								month: 'short',
								day: 'numeric',
								year: 'numeric'
							});
					};

					const displayDate = event.startDate === event.endDate
						? formatDate(event.startDate)
						: `${formatDate(event.startDate)}`;

					return (
						<div key={event.id} className="text-center lg:flex">
							<div className='lg:w-1/12'><img src={Reelit} alt={event.name} title={event.name} className='w-16 lg:h-auto mx-auto' /></div>
							<div className="font-semibold text-lg lg:w-11/12 pt-5">{event.name} {event.description} | {displayDate} &nbsp; &nbsp; <Link href={event.Link} target='_blank' rel="noopener noreferrer">{event.Button}</Link></div>
							{/* <p className="text-sm mb-2"></p>
							<p className="text-sm">{displayDate}</p> */}
							{/* <div className='pt-5'>
								<ThemeProvider theme={theme}>
									<Button variant="contained" size="large" color="secondary" ><Link style={{ color: '#ffffff' }} href={event.Link}>{event.Button}</Link></Button>
								</ThemeProvider>
							</div> */}
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default Events;